import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';

import { getTokenInfo } from '../../../UseToken';
import { reqGET, reqPUT } from '../../../Utils';
import Loader from '../../Loader/Loader';
import ReactQuill from 'react-quill';

import { color } from "../../WEBContent/Color";
import { icon } from "../../WEBContent/Icon";
import { language } from "./Language";

import { api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);
    const [lang, set_lang] = useState('pt');

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    const [userId, setUserId] = useState(null);
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState(null);
    const [input, setInput] = useState('');

    const [originalResponsaveis, setOriginalResponsaveis] = useState([]);
    const [addedMembers, setAddedMembers] = useState([]);
    const [removedMembers, setRemovedMembers] = useState([]);

    const messagesEndRef = useRef(null);
    const MAX_RESPONSAVEIS_DISPLAY = 4;

    const responsaveis = dados.info.responsaveis || [];
    const displayed = responsaveis.slice(0, MAX_RESPONSAVEIS_DISPLAY);
    const hidden = responsaveis.slice(MAX_RESPONSAVEIS_DISPLAY);
    const hasExtra = hidden.length > 0;

    const styles = {
        container: {
            width: "100%",
            maxWidth: "800px",
            margin: "60px auto",
            minHeight: "600px",
            display: "flex",
            flexDirection: "column",
            border: "1px solid #ddd",
            borderRadius: 12,
            padding: 24,
            backgroundColor: "#fff",
            boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
        },
        header: {
            borderBottom: "1px solid #ddd",
            paddingBottom: "8px",
            marginBottom: "16px",
        },
        messages: {
            flex: 1,
            minHeight: "500px",
            maxHeight: "500px",
            overflowY: "auto",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fafafa",
            display: "flex",
            flexDirection: "column",
        },
    };

    const messageStyles = {
        system: (color) => ({
            textAlign: "center",
            margin: "8px 0",
            fontSize: "0.85em",
            color,
            fontStyle: "italic",
            animation: "fadeIn 0.3s ease-in-out",
        }),
        messageContainer: (isUser) => ({
            position: "relative",
            alignSelf: isUser ? "flex-end" : "flex-start",
            background: isUser ? "#dcf8c6" : "#f1f1f1",
            borderRadius: "12px",
            padding: "10px 14px",
            margin: "6px 0",
            maxWidth: "70%",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            animation: "slideUp 0.25s ease-out",
        }),
        header: { fontSize: "0.9em", color: "#555", marginBottom: 4 },
        timestamp: { fontSize: "0.75em", textAlign: "right", color: "#999", marginTop: 4 },
        deleteButton: {
            position: "absolute",
            top: "10px",
            right: "100%",
            background: "transparent",
            border: "none",
            color: "#888",
            cursor: "pointer",
            fontSize: "0.9em",
            transition: "color 0.2s ease",
        },
    };

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);

    console.log('DADOS DO GRUPO', dados);

    useEffect(() => {
        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);

        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {

                if (data.user_info.user_info) {

                } else {

                    setUserId(data.user_info.id);
                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);

                }

            } else {
                console.log('User info nÃ£o encontrado no localStorage');
            }
        } else {
            console.log('Dados nÃ£o encontrados no localStorage');
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;

        const newSubmission = {
            userId,
            name,
            profile,
            timestamp: new Date().toISOString(),
            message: input
        };

        const updatedSubmissoes = [...(dados.info.submissoes || []), newSubmission];

        const updatedData = {
            ...dados,
            info: {
                ...dados.info,
                submissoes: updatedSubmissoes
            }
        };

        try {
            // Save to server
            await reqPUT(`${api_crud_route}`, updatedData);

            // Update local state after saving
            set_dados(updatedData);
            setInput('');

            // Scroll to bottom
            setTimeout(() => {
                if (messagesEndRef.current) {
                    messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);

        } catch (error) {
            console.error("Erro ao submeter a mensagem:", error);
        }
    };

    const handleDeleteMessage = async (index) => {
        const confirm = window.confirm("Tem a certeza que deseja remover esta mensagem?");
        if (!confirm) return;

        try {
            const updatedSubmissoes = [...dados.info.submissoes];
            updatedSubmissoes.splice(index, 1);

            const updatedData = {
                ...dados,
                info: {
                    ...dados.info,
                    submissoes: updatedSubmissoes
                }
            };

            await reqPUT(`${api_crud_route}`, updatedData);

            set_dados(updatedData);
        } catch (error) {
            console.error("Erro ao remover a mensagem:", error);
        }
    };

    useEffect(() => {
        if (!dados?.info?.responsaveis) return;

        if (originalResponsaveis.length === 0) {
            setOriginalResponsaveis([...dados.info.responsaveis]);
            return;
        }

        const current = dados.info.responsaveis;
        const originals = originalResponsaveis;

        const newOnes = current.filter(m => !originals.some(o => o.id === m.id));
        const removedOnes = originals.filter(o => !current.some(m => m.id === o.id));

        if (newOnes.length > 0) {
            console.log("NOVOS:", newOnes);
            setAddedMembers(newOnes);
        }

        if (removedOnes.length > 0) {
            console.log("REMOVIDOS:", removedOnes);
            setRemovedMembers(removedOnes);
        }

        if (newOnes.length > 0 || removedOnes.length > 0) {
            setTimeout(() => setOriginalResponsaveis([...current]), 100);
        }
    }, [dados?.info?.responsaveis]);

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <Loader />
            :
            <form id="form" onSubmit={handleSubmit}>
                <style>
                    {`
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(-4px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes slideUp {
                        from { opacity: 0; transform: translateY(10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    `}
                </style>

                <div style={styles.container}>
                    {/* Header */}
                    <div style={styles.header}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '10px' }}>
                            {dados.info.foto?.[0]?.link?.trim() ? (
                                <img
                                    src={dados.info.foto[0].link}
                                    alt="profile"
                                    style={{
                                        width: 75,
                                        height: 75,
                                        borderRadius: '50%',
                                        border: `1px solid ${dados.info.color?.primary || '#ccc'}`,
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: 75,
                                        height: 75,
                                        borderRadius: '50%',
                                        backgroundColor: dados.info.color?.primary || '#ccc',
                                    }}
                                />
                            )}

                            <div>
                                <h1 style={{ fontSize: '1.2em', margin: '4px 0' }}>{dados.info.name}</h1>
                                <h2 style={{ fontSize: '1em', fontWeight: 'normal', margin: '2px 0' }}>
                                    {dados.info.description}
                                </h2>
                                <h3 style={{ fontSize: '0.9em', fontWeight: 'normal', margin: '2px 0', color: '#666' }}>
                                    {responsaveis.length > 0 ? (
                                        <>
                                            {language[lang].mem}: {displayed.map(r => r.name).join(', ')}
                                            {hasExtra && (
                                                <span
                                                    title={hidden.map(r => r.name).join(', ')}
                                                    style={{ color: '#007bff', cursor: 'pointer' }}
                                                >
                                                    {' '}+{hidden.length} {language[lang].mais}
                                                </span>
                                            )}
                                        </>
                                    ) : (
                                        'Nenhum responsável definido'
                                    )}
                                </h3>
                            </div>

                        </div>
                    </div>

                    {/* Messages */}
                    <div style={styles.messages}>
                        {console.log('originalResponsaveis', originalResponsaveis)}
                        {addedMembers.length > 0 && (
                            <div style={messageStyles.system("#4caf50")}>
                                {addedMembers
                                    .map(
                                        (m) =>
                                            `${m.label || m.nome || m.name} foi adicionado${m.nome?.endsWith("a") ? "a" : ""}.`
                                    )
                                    .join(" ")}
                            </div>
                        )}

                        {removedMembers.length > 0 && (
                            <div style={messageStyles.system("#f44336")}>
                                {removedMembers
                                    .map(
                                        (m) =>
                                            `${m.label || m.nome || m.name} foi removido${m.nome?.endsWith("a") ? "a" : ""}.`
                                    )
                                    .join(" ")}
                            </div>
                        )}

                        {dados.info.submissoes.map((msg, idx) => {
                            const isUser = msg.userId === userId;
                            return (
                                <div key={idx} style={messageStyles.messageContainer(isUser)}>
                                    {isUser && (
                                        <button
                                            onClick={() => handleDeleteMessage(idx)}
                                            style={messageStyles.deleteButton}
                                            title={language[lang].remover || "Remover mensagem"}
                                            onMouseEnter={(e) => (e.currentTarget.style.color = "#e53935")}
                                            onMouseLeave={(e) => (e.currentTarget.style.color = "#888")}
                                        >
                                            <i className={icon.trash.className}></i>
                                        </button>
                                    )}

                                    <div style={messageStyles.header}>
                                        {msg.name} ({msg.profile})
                                    </div>
                                    <div style={{ wordBreak: "break-word" }}>{msg.message}</div>
                                    <div style={messageStyles.timestamp}>
                                        {new Date(msg.timestamp).toLocaleDateString("pt-PT", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        })}{" "}
                                        {new Date(msg.timestamp).toLocaleTimeString("pt-PT", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </div>
                                </div>
                            );
                        })}

                        <div ref={messagesEndRef} />
                    </div>

                    {/* Input */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 10 }}>
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => e.target.value.length <= 300 && setInput(e.target.value)}
                            placeholder={language[lang].mensagem_placeholder}
                            style={{
                                flex: 1,
                                padding: "10px 12px",
                                fontSize: "1em",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                outline: "none",
                                transition: "border-color 0.2s ease",
                            }}
                            onFocus={(e) => (e.target.style.borderColor = "#4caf50")}
                            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                        />
                        <button
                            type="submit"
                            style={{
                                padding: "10px 18px",
                                borderRadius: "8px",
                                border: "none",
                                backgroundColor: "#4caf50",
                                color: "white",
                                fontWeight: "bold",
                                cursor: "pointer",
                                transition: "background-color 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#43a047")}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#4caf50")}
                        >
                            {language[lang].enviar}
                        </button>
                    </div>
                </div>
            </form>;
}